import React from "react";
import { ToastContainer } from "react-toastify";
import styled from "styled-components";
import { Radius, Spacing } from "@glossy";
import { message, useTheme } from "@glossy/theme";
import { GlossyTheme } from "@glossy/theme/types";
import Icon, { Glyph } from "@ui-kit/icon";
import "react-toastify/dist/ReactToastify.min.css";

interface IProps {
  message: string;
  icon?: Glyph;
  description?: string;
}

const WrappedToastContainer = (props) => {
  const theme = useTheme();
  return <ToastContainer theme={theme} {...props} />;
};

export const Container = styled(WrappedToastContainer)<{ theme: GlossyTheme }>`
  & {
    width: fit-content;
    min-width: 320px;
    max-width: 420px;
  }

  .Toastify__toast {
    min-height: 48px;
    border-radius: ${Radius.Medium};
    &--error {
      background: ${(props) => message({ theme: props.theme }, "error")};
    }
    &--info {
      background: ${(props) => message({ theme: props.theme }, "info")};
    }
    &--success {
      background: ${(props) => message({ theme: props.theme }, "success")};
    }
    &--warning {
      background: ${(props) => message({ theme: props.theme }, "warning")};
    }
  }
`;

const ContentRoot = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${Spacing.ExtraSmall};
  line-height: 1.2em;
`;

const Header = styled.div`
  display: flex;
  column-gap: ${Spacing.ExtraSmall};
  align-items: center;
  > * {
    flex-shrink: 0;
  }
`;

const Description = styled.div`
  margin-bottom: ${Spacing.ExtraSmall};
`;

export const Content = ({ message, icon, description }: IProps) => (
  <ContentRoot>
    <Header>
      {icon && <Icon glyph={icon} />}
      {message}
    </Header>
    {description && <Description>{description}</Description>}
  </ContentRoot>
);
